import React from 'react';

import { ProdStackManagerIntl } from 'types/i18n';
import { TextComponent } from 'design/text/textComponents';
import { LinkControlComponent } from 'design/linkControl';
import { SUPPORT_MAIL } from 'utils/constants';
import { ParagraphComponent } from 'design/paragraph';
import { normalizeProfileLike } from 'utils/profileLikeUtils';

export const prodStackManagerIntl: ProdStackManagerIntl = {
  emailConfirm: {
    titleText: 'Создание аккаунта',
    detailsText(email) {
      return (
        <TextComponent>
          <ParagraphComponent>
            Первые 14 дней использование программы — бесплатно.
          </ParagraphComponent>
          <ParagraphComponent>
            Пожалуйста, подтвердите указанный ранее email адрес:
          </ParagraphComponent>
          <ParagraphComponent>
            <TextComponent weight="bold">{email}</TextComponent>
          </ParagraphComponent>
        </TextComponent>
      );
    },
    primaryActionText: 'Подтвердить',
    secondaryActionText: 'Изменить',
  },
  promocodeForm: {
    titleText: 'Создание аккаунта',
    promocodeInputLabelText: 'Укажите ваш персональный код:',
    promocodeInputFallbackLabelText: 'Некорректный код, попробуйте еще раз:',
    hintText() {
      return (
        <TextComponent>
          Или напишите нам, чтобы получить код:{' '}
          <LinkControlComponent to={`mailto:${SUPPORT_MAIL}`}>
            <TextComponent color="accent" animatedColor>
              {SUPPORT_MAIL}
            </TextComponent>
          </LinkControlComponent>
        </TextComponent>
      );
    },
  },
  clientInfoForm: {
    titleText: 'Ваши данные',
    firstNameInputLabelText: 'Имя',
    middleNameInputLabelText: 'Отчество',
    lastNameInputLabelText: 'Фамилия',
    phoneInputLabelText: 'Ваш телефон',
    positionInputLabelText: 'Ваша должность',
    partnerCodeLabel:
      'Введите код партнера, который вас пригласил (если есть):',
    partnerFoundByCodeText(profile) {
      const name = normalizeProfileLike(profile).toShortestName();

      return `Ваш партнер: ${name}`;
    },
    nameInputLabelText: 'Название организации',
    locationInputLabelText: 'Страна регистрации',
    staffCountInputLabelText: 'Количество сотрудников',
    actionText: 'Продолжить',
    staffCountText(orgStaffCount) {
      switch (orgStaffCount) {
        case 'large':
          return 'более 500';
        case 'medium':
          return 'до 500';
        case 'small':
          return 'до 100';
        default:
          return '';
      }
    },
    partnerNotFoundByCodeText:
      'Партнер не найден. Введите код партнера еще раз:',
  },
  finishCredentials: {
    titleText: 'Ваши подчиненные зарегистрированы',
    detailsText:
      'Вашим подчиненным мы создали логины\nи одноразовые пароли для входа. Сохраните их\nи сообщите подчиненным.',
    printActionText: 'Распечатать',
    downloadActionText: 'Открыть PDF с данными подчиненных',
    submitText: 'Завершить регистрацию',
    tableFullNameHeadingText: 'Персона',
    tableLoginHeadingText: 'Логин',
    tablePasswordHeadingText: 'Пароль',
  },
  finishComplete: {
    titleText() {
      return (
        <TextComponent size="mppp">
          Ваш аккаунт создан и готов к работе.{'\n'}
          <TextComponent size="mppp" color="accent">
            Запишите логин
          </TextComponent>
          , чтобы не забыть.
        </TextComponent>
      );
    },
    detailsText(accountEmail) {
      return (
        <TextComponent>
          Ваш логин: <TextComponent size="mppp">{accountEmail}</TextComponent>
        </TextComponent>
      );
    },
    actionText: 'Войти в AGM',
  },
  fallback: {
    titleText: 'Упс...',
    descriptionText(mailLink, tgLink) {
      return (
        <TextComponent>
          <ParagraphComponent>
            Извините, создание аккаунта временно недоступно из-за большого
            количества запросов.
          </ParagraphComponent>
          <ParagraphComponent>
            Создайте аккаунт позже или обратитесь в поддержку:{'\n'}email{' '}
            {mailLink}, telegram {tgLink}
          </ParagraphComponent>
        </TextComponent>
      );
    },
    actionText: 'Создать аккаунт',
  },
};
